import { useUserProvider } from "./provider";
import { HStack, Text } from "@chakra-ui/react";
import "./index.css";
import { Link } from "react-router";
import useProfile from "../../hooks/data/useProfile";
import { TextEditable } from "../reusables";
/**
 *
 * @param {import("@chakra-ui/react").StackProps & import("./props").UserProps} props
 * @returns
 */
const Bio = (props) => {
  const user = useUserProvider();
  const { updateProfile } = useProfile();

  function handleChange({ bio }) {
    // console.log('Bio got:', bio)
    updateProfile({ uid: user.id, data: { bio } });
  }

  return (
    <HStack fontSize={"14px"} w="full" {...props}>
      {user.allowEdit ? (
        <TextEditable
          value={user?.bio}
          onChange={(text) => handleChange({ bio: text })}
          noOfLines={2}
          placeholder={
            user.allowEdit ? "Click here to add a bio" : "No bio added"
          }
          w="full"
          whiteSpace="pre-line"
          textOverflow="unset"
          wordBreak="break-word"
          maxCharCount={120}
        />
      ) : (
        <Text as={"h4"} noOfLines={2}>
          {user?.bio}
        </Text>
      )}

      {props.children}
    </HStack>
  );
};

export default Bio;
